// 密码状态相关的工具函数

// 常量定义
const ForceChangePasswordKey = 'FORCE_CHANGE_PASSWORD'
const ForceChangePasswordReasonKey = 'FORCE_CHANGE_PASSWORD_REASON'
const PasswordWillExpireKey = 'PASSWORD_WILL_EXPIRE'

// ========== 强制修改密码相关 ==========

/**
 * 获取是否需要强制修改密码
 * @returns {boolean} 是否需要强制修改密码
 */
export function getForceChangePassword() {
  return localStorage.getItem(ForceChangePasswordKey) === 'true'
}

/**
 * 设置是否需要强制修改密码
 * @param {boolean} forceChangePassword 是否需要强制修改密码
 */
export function setForceChangePassword(forceChangePassword) {
  localStorage.setItem(ForceChangePasswordKey, forceChangePassword)
}

/**
 * 移除强制修改密码状态
 */
export function removeForceChangePassword() {
  localStorage.removeItem(ForceChangePasswordKey)
  localStorage.removeItem(ForceChangePasswordReasonKey)
}

// ========== 强制修改密码原因相关 ==========

/**
 * 获取强制修改密码原因
 * @returns {number} 强制修改密码原因：1-密码不符合复杂度要求，2-密码已过期
 */
export function getForceChangePasswordReason() {
  return parseInt(localStorage.getItem(ForceChangePasswordReasonKey))
}

/**
 * 设置强制修改密码原因
 * @param {number} reason 强制修改密码原因：1-密码不符合复杂度要求，2-密码已过期
 */
export function setForceChangePasswordReason(reason) {
  localStorage.setItem(ForceChangePasswordReasonKey, reason)
}

/**
 * 移除强制修改密码原因
 */
export function removeForceChangePasswordReason() {
  localStorage.removeItem(ForceChangePasswordReasonKey)
}

// ========== 密码即将过期相关 ==========

/**
 * 获取密码是否即将过期
 * @returns {boolean} 密码是否即将过期
 */
export function getPasswordWillExpire() {
  return localStorage.getItem(PasswordWillExpireKey) === 'true'
}

/**
 * 设置密码是否即将过期
 * @param {boolean} passwordWillExpire 密码是否即将过期
 */
export function setPasswordWillExpire(passwordWillExpire) {
  localStorage.setItem(PasswordWillExpireKey, passwordWillExpire)
}

/**
 * 移除密码即将过期状态
 */
export function removePasswordWillExpire() {
  localStorage.removeItem(PasswordWillExpireKey)
}

// ========== 密码状态相关 ==========

/**
 * 清除所有密码状态
 */
export function clearPasswordStatus() {
  removeForceChangePassword()
  removeForceChangePasswordReason()
  removePasswordWillExpire()
}
